// extracted by mini-css-extract-plugin
module.exports = {"msg":"alert_msg__0Trh3"};